/**
 * created by tian ruo jun
 撤稿箱
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Divider, Input, Pagination, message, Popconfirm} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import BaseComponent from "../../../base/BaseComponent";
import moment from "moment";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import $Jq from "jquery";
import {HEADER_HEIGHT} from "../../../constants";

const {Search} = Input;

export default class DraftBox extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            params: {
                page: 1,
                size: 10,
                keywords: "",
                mediaId: ""
            },
            dataSource: [],
            count: 0,
            disable:1
        }
    }

    componentWillMount() {
        let mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        this.state.params.mediaId = mediaId;
        this.getData();
        let that = this;
        // 监听 EditorInformationOfWebEditor 页面发送的消息
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求媒体参数") {
                that.sendMediaParameters(e, that)
            } else if (message == "请求刷新父页面") {
                that.getData()
            }
        }, "DraftBox")
    }

    componentDidMount() {
        this.getMediaById()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let mediaId = nextProps.match.params.mediaId ? nextProps.match.params.mediaId : '';
        this.state.params.mediaId = mediaId;
        this.getData()
    }

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("DraftBox")
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    render() {
        let otherHeight = 70 + 15 +15 ; // header 70 margin 15 15 bottom 15
        return (
            <div className={'main'} style={{
                margin: '15px',
                height: `calc(100vh - ${otherHeight}px)`,
                borderRadius: '5px',
                overflow: 'hidden',
                background: 'rgb(255, 255, 255)'
            }}>
                <div className={'content'} style={{padding:'24px 30px 0 30px'}}>
                    {/*搜索及按钮区*/}
                    {this.renderSearch()}
                    {/*表格*/}
                    {this.renderTable()}
                </div>
                {this.renderPage()}
            </div>
        )
    }

    // 搜索
    renderSearch = () => {
        return (
            // 新增文章,网络管理,访问网站,搜索框
            <div style={{display: 'flex', justifyContent: 'flex-end',}}>
                <Search
                    allowClear={true}
                    placeholder={'请输入'}
                    onSearch={(val) => {
                        this.state.params.keywords = val;
                        this.getData()
                    }}
                    style={{width: 272, height: 32, paddingLeft: '24px'}}
                />
            </div>
        )
    };

    // 表格
    renderTable = () => {

        let otherHeight = 70 + 15 + 15 + 24 + 32 + 95; // header 70 margin 15 15 paddingTop 24 search32 marginTop16
        let height = document.body.clientHeight -otherHeight;
        let {dataSource}=this.state;
        return (
            <div style={{ marginTop: 16}} className="interval">
                <Scrollbars autoHeight autoHeightMax={height} autoHide >
                    <BaseTable columns={this.renderColumn()} dataSource={dataSource}  style={{overflowX:'hidden'}}/>
                </Scrollbars>
            </div>
        )
    };

    // 分页栏
    renderPage=()=>{
        let {count,params,dataSource}=this.state;
        if(!count) return <div style={{height:81}}></div>;
        if(!(dataSource&&dataSource.length>0) && params.page>1) {
            this.state.params.page = params.page-1;
            this.getData()
        }
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '24px 32px',}}
            >
                <Pagination
                    size="middle"
                    total={count}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={params.page}
                    pageSize={params.size}
                    onChange={(page, pageSize) => {
                        this.state.params.page = page;
                        this.getData()
                    }} //页码改变时回调
                    onShowSizeChange={(page, pageSize) => {
                        this.state.params.size = pageSize;
                        this.state.params.page = 1;
                        this.getData()
                    }} //每页条数改变回调
                />
            </div>
        )
    };

    renderColumn = () => {
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div title={text} style={{
                                display: 'flex',
                                cursor: 'pointer',
                            }}
                                 onClick={() => {
                                if(this.state.disable == 1){
                                    return false
                                } else {
                                    this.editStory(record.id)
                                }
                            }}>
                                <div style={{
                                    flex:1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    marginRight:8
                                }}>{text}</div>
                                {record.titlePic ?
                                    <Titlepicfile src={record.titlePic} style={{width:24,height:24,borderRadius: '2px'}}/>
                                    : null}
                            </div>
                        )
                    }
                },
                {
                    title: '原发布栏目',
                    dataIndex: 'contentName',
                    key: 'contentName',
                    width:200,
                },
                {
                    title: '发布日期',
                    dataIndex: 'newdate',
                    key: 'newdate',
                    width:200,
                    render: (text, record) => {
                        return moment(text).format("yyyy-MM-DD HH:mm")
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width:150,
                },
                {
                    title: '撤稿人',
                    dataIndex: 'operator',
                    key: 'operator',
                    width:150,
                    render: (text, record) => {
                        return <div
                            title={text}
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {text}
                        </div>
                    }
                },
                {
                    title: '撤稿时间',
                    dataIndex: 'operateTime',
                    key: 'operateTime',
                    width:200,
                    render: (text, record) => {
                        return moment(text).format("yyyy-MM-DD HH:mm")
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                    width:100,
                    render: (text, record) => {
                        return (
                            this.state.disable == 1 ? "" : <Popconfirm
                                title="删除后稿件无法还原，请确认是否删除？"
                                onConfirm={() => {
                                    this.delStory(text)
                                }}
                            >
                                <Button type={'link'} onClick={() => {
                                }}>删除</Button>
                            </Popconfirm>
                        )
                    }
                },
            ]
        )
    };

    getData = () => {
        this.request({
            url: "/cm-sites-pms/website/news/undoList",
            body: this.state.params,
            callBack: (res) => {
                let dataSource = [];
                let count = 0;
                if(res && res.data && res.count) {
                    dataSource = res.data;
                    count = res.count
                }
                this.setState({dataSource,count})
            }
        })
    };
    //获取当前状态是否为禁用
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.state.params.mediaId
            },
            callBack: (res) => {
                let disable = 0;
                if(res) {
                    disable = res.disable
                }
                this.setState({disable});
                console.log(this.state.disable,"123")
            }
        })
    };
    delStory = (webNewsId) => {
        if(!webNewsId) return message.info('数据丢失');
        this.request({
            url: "/cm-sites-pms/website/news/deleteById",
            method: "post",
            body: {webNewsId},
            callBack: (res) => {
                message.success('删除成功！');
                this.getData()
            }
        })
    };

    // 点击标题进入稿件编辑器
    editStory(id) {
        const editorWindow = window.openEditById({
            configName: "webEditor",
            id: id,
            params: {},
        });
        this.state.editorWindow = editorWindow;
    };

    //给子页面（编辑器）发送消息
    sendMediaParameters(e, that) {
        let editorWindow = that.state.editorWindow;
        if (editorWindow) { // 向子页面发送消息
            let mediaId = that.state.mediaId;
            this.state.editorWindow.postMessage(JSON.stringify({
                    mediaId: mediaId,
                    storyType: "default", // 这个参数影响编辑器调查询接口
                })
                , "*"
            )
        }
    };

}